import {
  teamsDarkTheme,
  teamsHighContrastTheme,
  teamsLightTheme,
} from '@fluentui/react-components';
import { colorPalletDark, colorPalletLight } from './colors';

export const selectedTheme = (themeString: string) =>
  themeString === 'dark'
    ? {
        ...teamsDarkTheme,
        ...colorPalletDark,
      }
    : themeString === 'contrast'
    ? teamsHighContrastTheme
    : {
        ...teamsLightTheme,
        ...colorPalletLight,
      };
